export const GET_ITEM_MAPPING = 'GET_ITEM_MAPPING';
export const GET_ITEM_MAPPING_SUCCESS = 'GET_ITEM_MAPPING_SUCCESS';
export const GET_ITEM_MAPPING_FAILED = 'GET_ITEM_MAPPING_FAILED';

export const ADD_ITEM_MAPPING = 'ADD_ITEM_MAPPING';
export const ADD_ITEM_MAPPING_SUCCESS = 'ADD_ITEM_MAPPING_SUCCESS';
export const ADD_ITEM_MAPPING_FAILED = 'ADD_ITEM_MAPPING_FAILED';

export const EDIT_ITEM_MAPPING = 'EDIT_ITEM_MAPPING';
export const EDIT_ITEM_MAPPING_SUCCESS = 'EDIT_ITEM_MAPPING_SUCCESS';
export const EDIT_ITEM_MAPPING_FAILED = 'EDIT_ITEM_MAPPING_FAILED';

export const DELETE_ITEM_MAPPING = 'DELETE_ITEM_MAPPING';
export const DELETE_ITEM_MAPPING_SUCCESS = 'DELETE_ITEM_MAPPING_SUCCESS';
export const DELETE_ITEM_MAPPING_FAILED = 'DELETE_ITEM_MAPPING_FAILED';
